<app-generic-drop-down
  [options]="clients"
  [title]="title"
  [shouldEmitOption]="true"
  (value)="getOption($event)"
></app-generic-drop-down>
